var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFacilitySwimmingPool = function SvgFacilitySwimmingPool(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 82,
    cy: 26,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,60.301663 C4.4848767,61.9471976 17.9227954,74.0591526 26.9117475,74.0591526 C35.9006996,74.0591526 45.6820253,59 54.3207565,59 C62.9594881,59 71.4950364,75.870446 81.19228,74.9647996 C90.889524,74.0591526 92.4186572,62.0661206 99,61.1838917",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,76.3016629 C4.4848767,77.9471976 17.9227954,90.0591526 26.9117475,90.0591526 C35.9006996,90.0591526 45.6820253,75 54.3207565,75 C62.9594881,75 71.4950364,91.870446 81.19228,90.9647996 C90.889524,90.0591526 92.4186572,78.0661206 99,77.1838918",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3726519,14.8273615 C24.7319993,13.1813893 36.2505513,13.9913186 45.928308,17.2571495 C55.0801387,21.1372252 58.3843768,24.8052441 61.5619813,29.0063203 C64.7395864,33.2073964 75,48.9568791 75,51.7291602 C75,54.5014414 72.4495419,56.3797769 71.7654599,55.8866409 C71.0813774,55.3935049 57.8173703,46.3774081 52.9587462,46.3774081 C48.1001218,46.3774081 38.9446014,52.9952868 36.0729097,54.4409639 C33.2012179,55.8866409 28.8658069,58.8693378 25.6332256,57.7567198 C22.4006443,56.6441018 19.7498475,53.259659 19.2715873,51.2591295 C18.9527471,49.9254431 26.7456983,43.6427074 42.6504408,32.4109222 C29.1714094,29.0832763 19.6054086,27.4194534 13.9524386,27.4194534 C6.99709983,24.3846537 6.13717094,20.1872898 11.3726519,14.8273615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFacilitySwimmingPool);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "facility-swimming-pool.b437bda203b974353b968d8a2c02332a.svg";